<div
    class="input-summary h-100 d-flex flex-column justify-content-between"
    data-cy="summary-container"
    [class.border-bottom]="!labelOnly"
    [class.border-warning]="isPending"
>
    <div
        class="form-label d-flex align-items-baseline"
        [class.mb-0]="labelOnly"
    >
        @if (isSensitive) {
            <wdx-icon
                class="text-muted me-2 pointer"
                ngbPopover="This field is sensitive"
                container="body"
                [icon]="ICON_SENSITIVE"
            ></wdx-icon>
        }
        <span [innerHtml]="label | markdownToHtml | safeHtml"></span>
        @if (isRequired) {
            <sup>
                <wdx-icon
                    class="ms-1 text-danger icon-container-size-fit"
                    [icon]="ICON_REQUIRED"
                ></wdx-icon>
            </sup>
        }
    </div>
    @if (!labelOnly) {
        <div
            class="input-wrapper__content ms-0 fw-bolder"
            [attr.data-cy]="cySelector"
        >
            <ng-content></ng-content>
        </div>
    }
</div>

@if (isPending) {
    <div
        class="text-warning"
        data-cy="summary-text-warning"
        [textContent]="
            'FORM_PENDING_CHANGE_FIELD_ERROR' | translateTokenisedString
        "
    ></div>
}
